import fallback from './fallback'
import sdk from './sdk'
import { localeDefaultFunc } from './localeFunc'
import { getLocaleCookie } from '@/utils/cookies'

export default function(platform: string, name: string): string {
  let message: string | undefined
  const localeCookie = getLocaleCookie()
  switch (platform.toLowerCase()) {
    case 'sdk': {
      message = sdk.get(name)
      break
    }
    default: {
      message = localeDefaultFunc[localeCookie || 'fallback'].get(name)
      break
    }
  }

  if (message === undefined) {
    message = fallback.get(name)
  }

  return message !== undefined ? message : name
}
